<template>
  <div class="see-main">
    <div class="prompt_info">点击单个项可进行评论回复</div>
    <div
      v-for="(item, index) in orderComment"
      :key="index"
      @click="handleCommentItem(item)"
    >
      <common-component :readOnly="false" :item="item" />
    </div>
    <div v-for="(item, index) in orderItemComment" :key="index">
      <div>
        <div class="order-item-info">
          <div class="order-item-title">{{ item.orderItem.productName }}</div>
          <div class="order-item-money">￥{{ item.orderItem.price / 100 }}</div>
          <div class="order-item-quantity">×{{ item.orderItem.quantity }}</div>
        </div>
      </div>
      <div
        v-for="item1 in item.orderComment"
        :key="item1.productId"
        @click="handleCommentItem(item1)"
      >
        <common-component :readOnly="false" :item="item1" />
      </div>
    </div>

    <van-dialog
      v-model="showCommeentDialog"
      :title="'回复“' + current.itemName + '”内容'"
      show-cancel-button
      confirm-button-text="回复"
      @cancel="handleCancel"
      @confirm="handleConfirmComment"
      confirmButtonColor="#2AB1E7"
    >
      <div style="width: 100%">
        <textarea
          class="comment-textarea"
          placeholder="请输入最多50个字的回复"
          placeholder-class="comment-textarea-placeholder"
          maxlength="50"
          @input="handleChangeInput"
          :value="commentValue"
        ></textarea>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderData: {},
      oid: "",
      orderComment: [],
      orderItemComment: [],
      showCommeentDialog: false,
      current: {},
      commentValue: "",
      shop: "",
    };
  },
  mounted() {
    let oid = this.$route.query.oid;
    this.oid = oid;
    this.orderData = JSON.parse(localStorage.getItem("o_" + oid));
    this.init();
  },
  methods: {
    init() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      this.loadData("001", this.oid);
      this.loadOrderItem(this.orderData.orderItems);
    },
    loadOrderItem(orderItems) {
      this.orderItemComment = [];
      let promiseList = (orderItems || []).map((item) => {
        let productId = item.productId;
        return this.loadData("002", productId, item); //productId
      });
      Promise.all(promiseList)
        .then((item) => {
          this.$toast.clear();
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },
    getOrderaItemByProductId(productId) {
      return this.orderData.orderItems.find((item) => {
        return item.productId == productId;
      });
    },
    loadData(entityCode, oid, oItem = {}) {
      let orderData = this.orderData;
      let orderBizData = {
        "001": {
          "1_merchantId": orderData.shopId, //orderData.shopId
          "2_branchId": orderData.branchId || 9, // TODO: 等字段中orderData.branchId ||
        },
        "002": {
          "1_merchantId": orderData.shopId, //orderData.shopId
          "2_branchId": orderData.branchId || 9, // TODO: 等字段中orderData.branchId ||
          "3_orderNo": orderData.orderNo, //orderData.orderNo
          "4_productId": oItem.productId, //oItem.productId
        },
      };
      this.$authAjax
        .post("/comment/record/getCommentRecords", {
          entityCode: entityCode,
          entityId: oid,
          bizId: orderBizData[entityCode],
        })
        .then((res) => {
          let { data } = res.data;
          let orderComment = (data || []).map((item) => {
            return Object.assign({}, item, {
              name: item.itemName || "无名称",
              score: item.score || 0,
              content: item.content || "",
              files: item.files || [],
            });
          });
          if (entityCode == "001") {
            this.orderComment = orderComment;
          } else if (entityCode == "002") {
            let orderItem = this.getOrderaItemByProductId(oid);

            let orderItemComment = this.orderItemComment;
            orderItemComment.push({
              orderComment,
              orderItem,
            });
            this.orderItemComment = orderItemComment;
          }
        });
    },
    handleCommentItem(item) {
      if (item.appendContent) {
        if (this.shop && item.appendContent.merchantComment) {
          return;
        } else if (!this.shop && item.appendContent.userComment) {
          return;
        }
      }
      console.log(item);
      this.current = item;
      this.showCommeentDialog = true;
    },
    handleCancel() {
      this.showCommeentDialog = false;
      this.commentValue = "";
    },
    handleChangeInput(e) {
      this.commentValue = e.target.value;
    },
    handleConfirmComment() {
      if (this.commentValue == "") {
        this.$toast("内容不能为空");
        return;
      }
      let reqData = {
        appendItemId: this.current.id,
        appendUser: this.current.commentUser,
        isCustomerComment: true,
        appendContent: this.current.appendContent || {},
      };

      if (this.current.entityCode == "002") {
        let orderData = this.orderData;
        reqData.bizId = {
          "1_merchantId": orderData.shopId,
          "2_branchId": orderData.branchId || 9, // TODO: 等字段中
          "3_orderNo": orderData.orderNo,
          "4_productId": this.current.entityId,
        };
      }
      reqData.appendContent.merchantComment = this.commentValue;
      this.$authAjax.post("/comment/record/appendComment", reqData).then((res) => {
        console.log(res);
        this.$toast.success("评论成功");
        this.init();
        this.$toast.clear();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.see-main {
  width: 100%;
  height: 100vh;
  background: #f7f8fa;
  overflow: auto;
  padding: 14px;
  box-sizing: border-box;
  .prompt_info {
    padding: 6px 12px;
    background-color: rgb(255, 201, 25);
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    border-radius: 2px;
  }
  .order-item-info {
    padding-left: 14px;
    display: flex;
    // flex-direction: column;
    justify-content: space-around;
    margin-top: 20px;
    .order-item-title {
      font-size: 17px;
      color: #333;
      font-weight: bold;
      line-height: 1.6;
    }
    .order-item-money {
      color: rgb(199, 13, 13);
      line-height: 1.2;
    }
    .order-item-quantity {
      color: #666;
      line-height: 1;
    }
  }
}
.comment-textarea {
  border: none;
  height: 140px;
  padding: 20px;
  width: 100%;
  padding: 18px;
  box-shadow: border-box;
}
.comment-textarea-placeholder {
  color: #aaa;
  font-size: 17px;
}
</style>